import { render, staticRenderFns } from "./AcademicReferencesBasic.vue?vue&type=template&id=50bd05e3&"
import script from "./AcademicReferencesBasic.vue?vue&type=script&lang=js&"
export * from "./AcademicReferencesBasic.vue?vue&type=script&lang=js&"
import style0 from "./AcademicReferencesBasic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports